module.exports = __webpack_public_path__ + "static/media/train.34c0789c.svg";